import SelectClients from '../components/Selects/SelectClients';
import SelectStatuses from '../components/Selects/SelectStatuses';
import SelectDealPaymentStatuses from '../components/Selects/selectDealPaymentStatuses';
import Datepicker from '../components/Inputs/Datepicker/Datepicker';
import SelectPaymentTypes from '../components/Selects/SelectPaymentTypes';
import Select from '../components/Select/Select';
import SelectManager from '../components/Selects/SelectManager';
import SelectContainers from '../components/Selects/SelectContainers';
import SelectSources from '../components/Selects/SelectSources';
import SelectDealStatuses from '../components/Selects/SelectDealStatuses';
import SelectLeadDealStatus from '../components/Selects/SelectLeadDealStatus';
import SelectComplectations from '../components/Selects/SelectComplectations';
import SelectFacet from '../components/Selects/SelectFacet';
import SelectStockCar from '../components/Selects/SelectStockCar';
import SelectCity from '../components/Selects/SelectCity';
import SelectMarks from '../components/Selects/SelectMarks';
import SelectModels from '../components/Selects/SelectModels';

export const clientOptions = [
  { name: 'fio', label: 'ФИО клиента', placeholder: 'ФИО клиента' },
  { name: 'iin', label: 'ИИН', placeholder: 'ИИН клиента' },
  {
    name: 'vip',
    component: Select,
    label: 'VIP',
    placeholder: 'Выберите',
    options: [
      { value: true, label: 'Да' },
      { value: false, label: 'Нет' },
    ],
  },
  { name: 'company', label: 'Компания', placeholder: 'Компания' },
  { name: 'role', label: 'Должность', placeholder: 'Должность' },
  { name: 'phone', label: 'Телефон', placeholder: 'Телефон' },
  { name: 'email', label: 'E-mail', placeholder: 'E-mail' },
  {
    name: 'broker',
    label: 'Посредник',
    component: Select,
    placeholder: 'Выберите',
    options: [
      { value: true, label: 'Да' },
      { value: false, label: 'Нет' },
    ],
  },
];

export const servicesOptions = [
  { name: 'id', label: 'ИД', placeholder: 'Введите ИД' },
  { name: 'title', label: 'Название', placeholder: 'Введите название' },
  { name: 'price', label: 'Цена', placeholder: 'Введите цену' },
];

export const leadOptions = [
  { fio_label: 'ФИО лида', fio_placeholder: 'ФИО лида' },
  { iin_label: 'ИИН', iin_placeholder: 'ИИН лида' },
  { vip_label: 'VIP', vip_placeholder: 'Выберите' },
  { company_label: 'Компания', company_placeholder: 'Компания' },
  { role_label: 'Должность', role_placeholder: 'Должность' },
  { phone_label: 'Телефон', phone_placeholder: 'Телефон' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'Посредник', broker_placeholder: 'Выберите' },
];

export const dealOptions = [
  { fio_label: 'ФИО лида', fio_placeholder: 'ФИО лида' },
  { iin_label: 'ИИН', iin_placeholder: 'ИИН лида' },
  { vip_label: 'VIP', vip_placeholder: 'Выберите' },
  { company_label: 'Компания', company_placeholder: 'Компания' },
  { role_label: 'Должность', role_placeholder: 'Должность' },
  { phone_label: 'Телефон', phone_placeholder: 'Телефон' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'Посредник', broker_placeholder: 'Выберите' },
];

export const carsOptions = [
  { name: 'containerId', component: SelectContainers },
  { name: 'complectationId', component: SelectComplectations, params: () => carsOptions[0]?.value?.value },
  { name: 'markId', component: SelectMarks },
  {
    name: 'modelId', component: SelectModels,
    dependency: 'markId',
    dependencyAccessor: (obj) => obj?.value,
  },
  { name: 'stock', component: SelectStockCar, label: 'В наличии' },
  { name: 'cityId', component: SelectCity, label: 'Дилерский центр', placeholder: 'Выберите из списка' },
];

// Те же фильтры, что и carsOptions, но без "В наличии" — страница стоковых авто
// и так всегда показывает только сток (forApp=true+stock=true форсируется на
// уровне запроса), поэтому дублирующий переключатель тут только сбивал бы с толку
// Фильтры стока. Все варианты и счётчики приходят одним ответом getStockFilters и
// кладутся в поле options каждой опции (см. StockCars.jsx) — поэтому здесь нет ни
// dependency между марками и моделями, ни отдельных справочников: бэк уже вернул
// только то, что есть в текущей выборке. Порядок полей — как просили на странице.
export const stockCarsOptions = [
  { name: 'cityId', component: SelectFacet, label: 'Город', placeholder: 'Все города' },
  { name: 'dcId', component: SelectFacet, label: 'Дилерский центр', placeholder: 'Все ДЦ' },
  { name: 'markId', component: SelectFacet, label: 'Марка', placeholder: 'Все марки' },
  { name: 'modelId', component: SelectFacet, label: 'Модель', placeholder: 'Все модели' },
  { name: 'complectationId', component: SelectFacet, label: 'Комплектация', placeholder: 'Все комплектации' },
  { name: 'color', component: SelectFacet, label: 'Цвет', placeholder: 'Все цвета' },
  { name: 'wdId', component: SelectFacet, label: 'Привод', placeholder: 'Любой привод' },
  { name: 'engineVolume', component: SelectFacet, label: 'Объём двигателя, см³', placeholder: 'Любой объём' },
];

export const equipmentOptions = [
  { name: 'id', label: 'ИД', placeholder: 'Введите ИД' },
  { name: 'title', label: 'Название', placeholder: 'Введите название' },
  { name: 'price', label: 'Цена', placeholder: 'Введите цену' },
  {
    name: 'typeId',
    component: Select,
    label: 'Тип',
    placeholder: 'Выберите из списка',
    options: [
      { value: 1, label: 'Комплект' },
      { value: 2, label: 'Штука' },
    ],
  },
];

export const reportOptions = [
  { fio_label: 'Дата', fio_placeholder: 'Введите' },
  { iin_label: 'ИИН', iin_placeholder: 'ИИН лида' },
  { vip_label: 'VIP', vip_placeholder: 'Выберите' },
  { company_label: 'Компания', company_placeholder: 'Компания' },
  { role_label: 'Должность', role_placeholder: 'Должность' },
  { phone_label: 'Телефон', phone_placeholder: 'Телефон' },
  { email_label: 'E-mail', email_placeholder: 'E-mail' },
  { broker_label: 'Посредник', broker_placeholder: 'Выберите' },
];

// isClearable — чтобы выбранное значение снималось прямо в селекте: иначе один
// фильтр из нескольких убирался только сбросом всех.
export const leadsOptions = [
  { name: 'createdAt', component: Datepicker, label: 'Дата', placeholder: 'дд-мм-гггг', isClearable: true },
  { name: 'clientId', component: SelectClients, isClearable: true },
  {
    name: 'managerId',
    component: SelectManager,
    label: 'Менеджер',
    placeholder: 'Выберите из списка',
    isClearable: true,
  },
  { name: 'fio', label: 'ФИО клиента', placeholder: 'ФИО клиента' },
  {
    name: 'markAndModel',
    component: SelectContainers,
    label: 'Марка и модель',
    placeholder: 'Выберите из списка',
    isClearable: true,
  },
  {
    name: 'sourceId',
    component: SelectSources,
    label: 'Источник',
    placeholder: 'Выберите из списка',
    isClearable: true,
  },
  { name: 'phone', label: 'Телефон', placeholder: 'Телефон' },
  { name: 'email', label: 'E-mail', placeholder: 'E-mail' },
  // Это статус лида (SelectStatuses тянет getLeadStatuses), а плейсхолдер обещал сделку.
  {
    name: 'statusId',
    component: SelectStatuses,
    label: 'Статус лида',
    placeholder: 'Выберите статус лида',
    isClearable: true,
  },
  // Оба фильтра смотрят на последнюю сделку лида — ту же, что показана в колонке «Сделка».
  {
    name: 'dealStatusId',
    component: SelectLeadDealStatus,
    label: 'Статус сделки',
    placeholder: 'Выберите статус сделки',
    isClearable: true,
  },
  {
    // Строки, а не булевы: false не должен теряться как «пустое» значение в адресе и в подписях фильтров.
    name: 'dealApproved',
    component: Select,
    label: 'Одобрение банка',
    placeholder: 'Выберите',
    isClearable: true,
    options: [
      { value: 'true', label: 'Есть одобрение' },
      { value: 'false', label: 'Нет одобрения' },
    ],
  },
];

export const dealsOptions = [
  { name: 'createdAt', component: Datepicker, label: 'Дата', placeholder: 'дд-мм-гггг' },
  { name: 'clientId', component: SelectClients },
  { name: 'sum', label: 'Сумма контракта, KZT', placeholder: 'Введите сумму контракта' },
  { name: 'statusPaymentId', component: SelectDealPaymentStatuses, placeholder: 'Выберите статус сделки' },
  {
    name: 'statusId',
    component: SelectDealStatuses,
    label: 'Статус сделки',
    placeholder: 'Выберите статус сделки',
    defaultValue: { paymentTypeId: 0 },
  },
  { name: 'paymentType', component: SelectPaymentTypes, label: 'Форма оплаты', placeholder: 'Выберите форму оплаты' },
];
